import React from 'react';
import { Card } from 'antd';
import { dateFormat } from '../utils';
import iptEvent from '../assets/ipt_event.png';
import pteEvent from '../assets/pte_event.png';

function getTournamentImage(event) {
    if (event && event.img) {
        return event.img
    }
    if (event && event.type) {
        if (event.type.id === 4) {
            return pteEvent
        }
    }
    return iptEvent
}

function TournamentCard(props) {
    return (
        <Card 
            className="event-card" 
            cover={<img alt={props.tournament.name} className="event-img-top" src={getTournamentImage(props.tournament)} height="550px" />}>
            <Card.Meta title={props.tournament.name} description={dateFormat(props.tournament.date)} />
        </Card>
    );
}

export default TournamentCard;